import { Map } from 'immutable';

import * as t from '../../actions/dashboardActionType';

const initialState = Map({
  selectDefaulOption: 'THIS WEEK',
  activityData: {},
});

const reducer = function activityReducer(state = initialState, action) {
  switch (action.type) {
    case t.SET_ACTIVITY:
      return state.set('activityData', action.activityData);
    default:
      return state;
  }
};

export default reducer;
